<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="info">
            <b-navbar-brand to="/">EFOS</b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              
              <b-navbar-nav>
                  <b-nav-item to="/" >Buscar</b-nav-item>
                  <b-nav-item to="/admin/contributors" >Empresas</b-nav-item>
                  <b-nav-item to="/admin/users" >Usuarios</b-nav-item>
                  <!--
                  <b-nav-item href="/logs">Histórico</b-nav-item>
                  -->
              </b-navbar-nav>
              
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                  <b-nav-item-dropdown right>
                    <template slot="button-content"><em>{{username}}</em></template>
                    <b-dropdown-item to="/requests">Peticiones</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="logout()">Salir</b-dropdown-item>
                  </b-nav-item-dropdown>
              </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>

export default {
    name: 'NavBar',
    data: function() {
        return {
          user: {
            username: "Usuario"
          }
        }
    },
    computed : {
      isLoggedIn : function() { 
        return this.$store.getters.isLoggedIn; 
      },
      username: function() {
        return this.user.username;
      }
    },
    mounted() {
        var vm = this;
        const user = vm.$localStorage.get('user');
        if (user)
          vm.user = JSON.parse(user);
    },
    methods: {
      logout: function () {
        this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
      },
      reloadPage: function () {
        window.location.reload()
      }
    },
}
</script>